import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import StandardLayout from '../../components/layout/StandardLayout';

const CheckoutSimulator = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnPath = searchParams.get('return_to') || '/';
  const provider = searchParams.get('provider') || 'stripe';

  const handleSimulatePayment = () => {
    // Simulate successful payment
    navigate(`/payment-success?return_to=${encodeURIComponent(returnPath)}`);
  };

  return (
    <StandardLayout>
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="card bg-base-100 shadow-xl max-w-md w-full">
          <div className="card-body items-center text-center space-y-6">
            {/* Provider Logo */}
            <div className="rounded-full bg-primary/10 p-4">
              <CreditCardIcon className="w-12 h-12 text-primary" />
            </div>

            {/* Checkout Info */}
            <div className="space-y-3">
              <h1 className="text-2xl font-bold">
                {provider === 'paypal' ? 'PayPal Checkout' : 'Stripe Checkout'}
              </h1>
              <p className="text-base-content/70">
                Dies ist eine Simulation des {provider === 'paypal' ? 'PayPal' : 'Stripe'} Checkout-Prozesses.
              </p>
            </div>

            {/* Price Display */}
            <div className="bg-base-200 rounded-lg p-4 w-full">
              <div className="text-center">
                <span className="text-3xl font-bold">19,99 €</span>
                <span className="text-base-content/70 block text-sm mt-1">
                  1 Jahr Zugriff auf Mein-SKS
                </span>
              </div>
            </div>

            {/* Simulation Button */}
            <button 
              onClick={handleSimulatePayment}
              className="btn btn-primary w-full"
            >
              Zahlung simulieren
            </button>

            {/* Info Text */}
            <p className="text-xs text-base-content/60">
              Dies ist eine Simulation. In der Produktivumgebung würde hier der echte 
              {provider === 'paypal' ? ' PayPal' : ' Stripe'} Checkout erscheinen.
            </p>
          </div>
        </div>
      </div>
    </StandardLayout>
  );
};

export default CheckoutSimulator; 